import { baseRequest } from '@/lib/base';

// The `/api` prefix lives in VITE_APP_SERVER_URL, so paths start at /inventory/reports/.
export const fetchDashboard = (days = 7) => baseRequest({
    url: '/inventory/reports/dashboard/v2/',
    options: { params: { days } },
});
